window.addEventListener('DOMContentLoaded', (event) => {
  const topSlider = document.querySelector('.topSlider')
  if (topSlider) {
    const ul = topSlider.querySelector('.keen-slider')
    const count = topSlider.querySelector('.pageCount .current')
    const countAll = topSlider.querySelector('.pageCount .all')
    const children = Array.from(ul.children)
    const slide = KeenSlider(ul, {
      loop: true,
      slides: {
        perView: 1,
        spacing: 24
      },
      selector: children
    })
    if (countAll) {
        countAll.innerHTML = slide.track.details.slides.length
    }
    const arrows = topSlider.querySelectorAll('.arrow')
    arrows.forEach((arrow) => {
      const isNext = arrow.classList.contains('next')
      arrow.addEventListener('click', isNext ? slide.next : slide.prev)
    })
    const thumbnails = topSlider.querySelector('.thumbnails')
    Array.from(thumbnails.children).forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        slide.moveToIdx(index)
      })
    })
    slide.on('slideChanged', (instance) => {
      const current = instance.track.details.rel
      Array.from(thumbnails.children).forEach((child, index) => {
        child.classList = index === current ? ['active'] : []
      })
      if (count !== null) {
        count.innerHTML = current + 1
      }
    })

    // 拡大表示
    const li = ul.querySelectorAll('li')
    const overlay = topSlider.querySelector('.topSlider .overlay')
    const closeButton = overlay.querySelector('.close')
    const enlargedItem = overlay.querySelectorAll('.enlargedItem')
    let number = null
    li.forEach((slide, index) => {
      number = index
      slide.addEventListener('click', () => {
        overlay.style.display = 'block'
        // index番目の要素にcurrentクラス付与
        if (enlargedItem[index]) {
          enlargedItem[index].classList.add('current')
        }
      })
    })
    if (overlay) {
      closeButton.addEventListener('click', () => {
        overlay.style.display = 'none'
        enlargedItem.forEach(item => item.classList.remove('current'))
      })
    }
  }

  const categoryChips = document.querySelector('.categoryChips')
  if (categoryChips) {
    const nav = document.getElementById('globalNav')
    const rect = categoryChips.getBoundingClientRect()
    const offsetTop = window.pageYOffset + rect.top
    document.addEventListener('scroll', () => {
      const scroll = window.pageYOffset
      const top = offsetTop - scroll - nav.clientHeight - 1
      if (top < 0) {
        categoryChips.style.transform = `translateY(${-top}px)`
      } else {
        categoryChips.style.transform = null
      }
    })
  }

  // const galleryWrappers = document.querySelectorAll('.galleryWrapper')
  // const { createApp } = Vue
  // galleryWrappers.forEach((galleryWrapper) => {
  //   createApp({
  //     data () {
  //       return {
  //         slide: null,
  //         index: null
  //       }
  //     },
  //     mounted () {
  //       this.initSlide()
  //     },
  //     methods: {
  //       initSlide (val) {
  //         const sliderUl = this.$refs.slider
  //         if (!sliderUl) return
  //         const childrenArray = Array.from(sliderUl.children)
  //         this.slide = KeenSlider(this.$refs.slider, {
  //           initial: val,
  //           slides: {
  //             perView: 1,
  //             spacing: 24
  //           },
  //           selector: childrenArray
  //         })
  //       }
  //     },
  //     watch: {
  //       index (val) {
  //         this.$nextTick(() => {
  //           this.initSlide(val)
  //         })
  //       }
  //     }
  //   }).mount(galleryWrapper)
  // })

  // const reservation = document.querySelector('.reservation')
  // if (reservation) {
  //   createApp({
  //     data () {
  //       return {
  //         show: false,
  //         slide: null,
  //         index: 0
  //       }
  //     },
  //     mounted () {
  //       this.initSlide()
  //     },
  //     methods: {
  //       initSlide () {
  //         const sliderUl = this.$refs.slider
  //         if (!sliderUl) return
  //         const childrenArray = Array.from(sliderUl.children)
  //         this.slide = KeenSlider(this.$refs.slider, {
  //           initial: this.index,
  //           slides: {
  //             perView: 1
  //           },
  //           selector: childrenArray
  //         })
  //         this.slide.on('slideChanged', (instance) => {
  //           const current = instance.track.details.abs
  //           this.index = current
  //         })
  //       }
  //     },
  //     watch: {
  //       show (val) {
  //         if (!val) return
  //         this.$nextTick(() => {
  //           this.initSlide(val)
  //         })
  //       }
  //     }
  //   }).mount(reservation)
  // }

  const mapElementPc = document.getElementById("mapPc")
  const mapElementSp = document.getElementById("mapSp")
  let previousWindowWidth = window.innerWidth

  if (mapElementPc || mapElementSp) {
    const mapLatitudePc = mapElementPc.firstElementChild
    const mapCanvasPc = mapLatitudePc.firstChild
    const mapLatitudeSp = mapElementSp.firstElementChild
    const mapCanvasSp = mapLatitudeSp.firstChild

    if (previousWindowWidth >= 769) {
      mapLatitudePc.id = "js-longitude-latitude"
      mapCanvasPc.id = "map_canvas"
    } else if (previousWindowWidth <= 768) {
      mapLatitudeSp.id = "js-longitude-latitude"
      mapCanvasSp.id = "map_canvas"
    }

    initializeGoogleMap()

    window.addEventListener('resize', (event) => {
      const currentWindowWidth = window.innerWidth
      if (previousWindowWidth >= 769) {
        if (currentWindowWidth <= 768) {
          mapLatitudePc.id = ""
          mapCanvasPc.id = ""
          mapLatitudeSp.id = "js-longitude-latitude"
          mapCanvasSp.id = "map_canvas"
          initializeGoogleMap()
        }
      } else if (previousWindowWidth <= 768) {
        if (currentWindowWidth >= 769) {
          mapLatitudeSp.id = ""
          mapCanvasSp.id = ""
          mapLatitudePc.id = "js-longitude-latitude"
          mapCanvasPc.id = "map_canvas"
          initializeGoogleMap()
        }
      }
      previousWindowWidth = currentWindowWidth
    })
  }
})

function initializeGoogleMap() {
  let longitudeLatitude = document.getElementById('js-longitude-latitude');
  if (longitudeLatitude) {
    let longitude = toFloat(longitudeLatitude.getAttribute('data-longitude'));
    let latitude = toFloat(longitudeLatitude.getAttribute('data-latitude'));
    let shopName = longitudeLatitude.getAttribute('data-shop-name');
    let position = {lat: latitude, lng: longitude};
    let map;
    window.initMap = function() {
        map = new google.maps.Map(document.getElementById('map_canvas'), {
            center: position,
            zoom: 16,
            scrollwheel: false
        });

        let officeContent = new google.maps.InfoWindow({
            content: shopName
        });
        let officeMaker = new google.maps.Marker({
            position: position,
            map: map,
            title: shopName
        });
        officeMaker.addListener('click', function() {
            officeContent.open(map, officeMaker);
        });
    }

    if (typeof google === 'undefined') {
        let el = document.createElement('script');
        el.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBlWHOhHdo22p_ijvADKZLBDjQRZeLPR7Y&callback=initMap';
        document.body.appendChild(el);
    } else {
        initMap();
    }
  }
}


function toFloat(str) {
  return parseInt(str * 1000000, 10) / 1000000;
}
